<template>
  <div id="app">
    <div v-if="$route.name !== 'login'">
      <Sidebar />
      <div v-if="$route.name == 'home'"></div>
      <div class="app-content" :class="{ 'profile': $route.name == 'home' }">
        <AppHeader />

        <!-- ===== SOLO ENVUELVO EL ROUTER-VIEW CON TRANSITION ===== -->
        <transition name="fade-slide" mode="out-in" appear>
          <router-view :key="$route.fullPath" />
        </transition>

        <AppFooter />
      </div>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/partials/Header.vue'
import AppFooter from '@/components/partials/Footer.vue'
import Sidebar from './components/partials/Sidebar.vue'

export default {
  name: 'app',
  components: {
    AppHeader,
    AppFooter,
    Sidebar,
  }
}
</script>

<style>
/* ===== TRANSICIONES ===== */
.fade-slide-enter-active {
  transition: all 0.3s ease-out;
}

.fade-slide-leave-active {
  transition: all 0.25s ease-in;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}

/* ===== ESTILOS BASE ===== */
html, body {
  min-height: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

body {
  background: var(--third) !important;
}

#app {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
}

.app-content {
  min-height: 100vh;
  position: relative;
  z-index: 1;
  margin-left: 80px !important;
  display: flex;
  flex-direction: column;
  /* Reservamos espacio para el margen inferior del footer */
  padding-bottom: 2rem;
  box-sizing: border-box;
}

/* ===== PADDING HORIZONTAL EN PANTALLAS GRANDES ===== */
@media (min-width: 769px) {
  .app-content {
    padding-left: 60px !important;
    padding-right: 60px !important;
  }
}

.app-content > * {
  flex-shrink: 0;
}

/* ===== EL ROUTER-VIEW ===== */
.app-content > router-view {
  flex: 1;
}

/* ===== LA TRANSICIÓN TAMBIÉN DEBE OCUPAR EL ESPACIO ===== */
.app-content > .fade-slide-enter-active,
.app-content > .fade-slide-leave-active,
.app-content > .fade-slide-enter-from,
.app-content > .fade-slide-leave-to {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* ===== EL ROUTER-VIEW DENTRO DE LA TRANSICIÓN ===== */
.app-content > .fade-slide-enter-active > router-view,
.app-content > .fade-slide-leave-active > router-view,
.app-content > .fade-slide-enter-from > router-view,
.app-content > .fade-slide-leave-to > router-view {
  flex: 1;
  min-height: 0;
}

/* ===== FOOTER: SIEMPRE PEGADO AL FONDO ===== */
.app-content > footer,
.app-content > .footer,
.app-content > #footer {
  margin-top: auto;
  flex-shrink: 0;
}

input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

:focus {
  outline: -webkit-focus-ring-color auto 0px;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
}

::-webkit-scrollbar:vertical {
  width: 0.3rem;
}

::-webkit-scrollbar:horizontal {
  height: 0.3rem;
}

::-webkit-scrollbar-track {
  background: #eeeeee;
}

::-webkit-scrollbar-thumb {
  background: var(--first-op);
}

a {
  color: #2c3e50 !important;
}

a:hover, a:hover * {
  text-decoration: none !important;
  color: inherit;
}

.btn.focus, .btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(80 80 80 / 25%);
}
</style>